import React from "react";
import { NewsItem } from "./NewItem";
import { INewsItem } from "@/types/news";

interface MonthGroupProps {
  monthYear: string;
  items: INewsItem[];
  locale: string;
}
/**
 * MonthGroup Component
 *
 * Displays a group of news items categorized by month and year.
 * Renders a section header showing the month-year and a list of related news items.
 */
export const MonthGroup: React.FC<MonthGroupProps> = ({
  monthYear,
  items,
  locale,
}) => {
  return (
    <div className="mb-2">
      <div className="w-full border-b border-b-[var(--fill-secondary-solid-normal)]">
        <div className="inline-block bg-[var(--fill-secondary-solid-normal)] px-8 py-4 text-[14px]">
          <span className="font-[var(--font-bold)]">{monthYear}</span>
        </div>
      </div>
      <div className="divide-y divide-[var(--fill-base-gray)]">
        {items.map((item, index) => (
          <NewsItem
            key={item.item_name}
            item={item}
            isLastItem={index === (items?.length ?? 0) - 1}
            locale={locale}
          />
        ))}
      </div>
    </div>
  );
};
